import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CompanyCodesGrid from './companyCodesGrid.component';

import { companyCodesSelector } from '../../../shared/store/selectors';

import { useClearBalanceSheetManagementBalances, useUnlockAllTaxEntries } from '../../../shared/mutations/clientAdministration';
import { CompanyCode } from '../types';
import { CompanyCodePropTypes } from '../propTypes';
import { TabHeader } from '../shared/tabHeader.component';
import { AdminOption } from '../shared/adminOption.component';

type BalanceSheetManagementTabProps = {
  companyCodes: CompanyCode[]
}

const BalanceSheetManagementTab: React.FC<BalanceSheetManagementTabProps> = ({
  companyCodes,
}) => {
  const {
    isLoading: isLoadingClearBsmBalances,
    mutate: clearBsmBalancesInAllPeriods,
  } = useClearBalanceSheetManagementBalances();
  const {
    isLoading: isLoadingUnlockTaxEntries,
    mutate: unlockAllTaxEntries,
  } = useUnlockAllTaxEntries();

  return (
    <div className="client-admin-bsm-tab">
      <div className="container-fluid">
        <div className="application-settings-form">
          <TabHeader label="Balance Sheet Management" />
          <AdminOption
            label="Unlock all tax entries"
            buttonLabel="Unlock"
            isLoading={isLoadingUnlockTaxEntries}
            onClick={unlockAllTaxEntries}
          />
          <div className="company-codes-grid">
            <CompanyCodesGrid
              clearBsmBalances={clearBsmBalancesInAllPeriods}
              isLoadingClearBsmBalances={isLoadingClearBsmBalances}
              companyCodes={companyCodes}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

BalanceSheetManagementTab.propTypes = {
  companyCodes: PropTypes.arrayOf(CompanyCodePropTypes.isRequired).isRequired,
};


const mapStateToProps = (state: any) => ({
  companyCodes: companyCodesSelector(state),
});

export default connect(mapStateToProps)(BalanceSheetManagementTab);
